import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import { throwOnError } from '../utils/throwOnError'
import type { paths } from '../types/prove-v1'

export type Reinbeitedistrikt =
  paths['/reinbeitedistrikter']['get']['responses'][200]['content']['application/json'][number]

type AuthFetch = ReturnType<typeof useAuth>['authFetch']

export const getReinbeitedistrikterQueryOptions = (
  authFetch: AuthFetch,
  search: string,
  enabled = true
) =>
  queryOptions({
    queryKey: ['reinbeitedistrikter', search],
    queryFn: enabled
      ? async ({ signal }) => {
          const { data, error } = await authFetch().GET(
            '/reinbeitedistrikter',
            {
              params: { query: { search } },
              signal
            }
          )
          if (error) throwOnError(error)
          return data ?? []
        }
      : skipToken
  })

export const useGetReinbeitedistrikterQuery = (
  search: string,
  enabled = true
) => {
  const { authFetch } = useAuth()
  return useQuery(
    getReinbeitedistrikterQueryOptions(authFetch, search, enabled)
  )
}
